export default __webpack_public_path__ + "static/media/arrow-right.db24b71f.svg";